import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./Header.css";

class Header extends Component {
  render() {
    // Prevent from rendering if the rest of the page content has not been shown
    // yet.
    if (!this.props.isPageLoaded) {
      return <div />;
    }

    return (
      <div className="type-header-container">
        <h4>
          <Link to="/">Michael Huynh</Link>
        </h4>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js